import React, {
  createContext,
  useReducer,
  useContext,
  ReactNode,
  Dispatch,
  useCallback
} from 'react'
import usePortal from 'react-useportal'

import {
  INotiStateItem,
  NotiAction,
  ADD,
  REMOVE,
  REMOVE_ALL,
  REMOVE_ALL_AND_ADD
} from './interface.d'
import Notifications from './Notifications'

export const NotiContext = createContext<{
  notiList: INotiStateItem[]
  notiDispatch: Dispatch<NotiAction>
}>({
  notiList: [],
  notiDispatch: () => {
    return null
  }
})

const initialState: INotiStateItem[] = []

export const notiReducer = (state: INotiStateItem[], action: NotiAction) => {
  switch (action.type) {
    case ADD:
      return [
        ...state,
        {
          ...action.payload,
          id: +new Date()
        }
      ]
    case REMOVE:
      return state.filter((t) => t.id !== action.payload.id)
    case REMOVE_ALL:
      return initialState
    case REMOVE_ALL_AND_ADD:
      return [
        {
          ...action.payload,
          id: action.payload?.id || +new Date()
        }
      ]
    default:
      return state
  }
}

export const NotiProvider = ({ children }: { children: ReactNode }) => {
  const [notiList, _notiDispatch] = useReducer(notiReducer, initialState)
  const notiDispatch = useCallback((...args: Parameters<typeof _notiDispatch>) => {
    _notiDispatch(...args)
  }, [])
  const notiData = { notiList, notiDispatch }
  const { Portal } = usePortal()
  return (
    <NotiContext.Provider value={notiData}>
      {children}
      <Portal>
        <Notifications notiList={notiList} />
      </Portal>
    </NotiContext.Provider>
  )
}

export const useNotiContext = () => {
  return useContext(NotiContext)
}
